import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SearchableSelect from "../../../components/SearchableSelect";
import { fetchLocationMap, addLocationMap } from "../../../slices/LocationSlice/locationMapSlice";
import { fetchCountryList } from "../../../slices/LocationSlice/countrySlice";
import {fetchSubCategoryList} from "../../../slices/LocationSlice/subCategorySlice"


const AddLocationMap = ({countryList, subCategoryList}) => {
  const dispatch = useDispatch(); 
  const country = useSelector((state)=>state.countryList);
  const subCategory = useSelector((state)=>state.subCategory);
  const [formData, setFormData] = useState({
    title: "",
    variableName:"",
    country:"",
    category:"",
  });

  useEffect(()=>{
    console.log(country.status)
    console.log(subCategory.status)
    
    if(country.status=="idle"){
      fetchCountryList()
    }

    if(subCategory.status=="idle"){
      fetchSubCategoryList()
    }
      
  },[dispatch]) 

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "val" || name === "optionType" ? Number(value) : value,
    }));

  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      title: formData.title,
      variableName:formData.variableName,
      country:formData.country,
      category:formData.category
    };

    const resp = await dispatch(addLocationMap(data));

    // Reset form
    if(!resp.error){
        setFormData({
          title: "",
          variableName:"",
          country:"",
          category:""
          });

    dispatch(fetchLocationMap());
    }
   
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 p-4 max-w-md mx-auto">
      <input
        type="text"
        name="title"
        placeholder="Title"
        value={formData.title}
        onChange={handleChange}
        className="w-full p-1 border rounded border-gray-400"
        required
      />
      
      {/* <input
        type="text"
        name="code"
        placeholder="Code"
        value={formData.code}
        onChange={handleChange}
        className="w-full p-1 border rounded border-gray-400"
        required
      /> */}
      <input
        type="text"
        name="variableName"
        placeholder="Variable Name"
        value={formData.variableName}
        onChange={handleChange}
        className="w-full p-1 border border-gray-400 rounded bg-white"
        required
      />
      {/* <select className="w-full p-1 border rounded" name="optionType" value={formData.optionType}  onChange={handleChange}>
       <option value="" disabled >
                        Select option type
                      </option>
                      {optionList?.result?.map((option, i) => (
                        <option key={i} value={option.id}>
                          {option.title}
                        </option>
                      ))}
      </select> */}

      {/* <select className="w-full p-1 border rounded" name="state" value={formData.state}  onChange={handleChange}>
       <option value="" disabled >
                        Select State
                      </option>
                      {stateList?.result?.map((option, i) => (
                        <option key={i} value={option.id}>
                          {option.title}
                        </option>
                      ))}
      </select> */}

{/* 
      <select className="w-full p-1 border rounded" name="pincode" value={formData.pincode}  onChange={handleChange}>
       <option value="" disabled >
                        Select Pincode
                      </option>
                      {pincodeList?.result?.map((option, i) => (
                        <option key={i} value={option.id}>
                          {option.title}
                        </option>
                      ))}
      </select> */}

      <SearchableSelect list={subCategoryList} formData={formData} handleChange={handleChange} name="category" placeholder="Select Category" />

      <SearchableSelect list={countryList} formData={formData} handleChange={handleChange} name="country" placeholder="Select Country" />

{/* 
      <select className="w-full p-1 border rounded" name="country" value={formData.country}  onChange={handleChange}>
       <option value="" disabled >
                        Select Country
                      </option>
                      {countryList?.result?.map((option, i) => (
                        <option key={i} value={option.id}>
                          {option.title}
                        </option>
                      ))}
      </select> */}

     
      <button
        type="submit"
        className="w-full bg-[var(--mainCol)] text-white p-2 rounded"
      >
        Add Location Map
      </button>
    </form>
  );
};

export default AddLocationMap;
